export default "__VITE_ASSET__QcZVJ9Ly__"